export const SET_VKS_STATUS = "SET_VKS_STATUS"
export const SET_VKS_MESSAGE = "SET_VKS_MESSAGE"
export const SET_VKS_LINK = "SET_VKS_LINK"
export const SET_VKS_PARTS = "SET_VKS_PARTS"
export const SET_VKS_INVITE_ROOM_INFO = "SET_VKS_INVITE_ROOM_INFO"
export const SET_VKS_ROOM_ERROR = "SET_VKS_ROOM_ERROR"